import { render } from "./Success.vue?vue&type=template&id=47957309&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"

import "./Success.vue?vue&type=style&index=0&id=47957309&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-47957309"

export default script